import { motion } from "framer-motion";

const isPh = (t) => (t || "").includes("à compléter");

function Step({ step, i, total }) {
  const left = i % 2 === 0;
  return (
    <motion.li initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: 0.05 }} className="relative grid grid-cols-[2.5rem_1fr] gap-4 md:grid-cols-[1fr_3rem_1fr] md:gap-8"
      data-testid={`timeline-step-${i}`}>
      <div className={`hidden md:block ${left ? "md:order-3" : "md:order-1"}`} aria-hidden="true" />
      <div className="relative flex justify-center md:order-2">
        <span className="z-10 mt-1 flex h-10 w-10 items-center justify-center rounded-full border-4 border-paper bg-gold font-display text-lg font-bold text-ink shadow">
          {i + 1}
        </span>
        {i < total - 1 && <span className="absolute top-11 bottom-[-2.5rem] w-0.5 bg-gold/50 md:hidden" aria-hidden="true" />}
      </div>
      <div className={`card p-6 ${left ? "md:order-1 md:text-right" : "md:order-3"}`}>
        <p className={`inline-block font-display text-sm font-bold uppercase tracking-[0.2em] ${isPh(step.date) ? "rounded border border-dashed border-gold px-2 py-0.5 text-neutral-500" : "text-ong"}`}
          data-testid={`timeline-date-${i}`}>{step.date}</p>
        <h3 className="mt-2 font-display text-2xl font-bold uppercase leading-tight text-ink" data-testid={`timeline-title-${i}`}>{step.title}</h3>
        <p className="mt-2 leading-relaxed text-neutral-700">{step.text}</p>
      </div>
    </motion.li>
  );
}

export function Timeline({ steps }) {
  if (!steps?.length) return null;
  return (
    <section className="bg-[#f3efe6] py-20" data-testid="maleba-timeline">
      <div className="container-x">
        <p className="font-display text-sm font-semibold uppercase tracking-[0.25em] text-gold">Frise</p>
        <h2 className="h2 mt-2">Les étapes de sa vie</h2>
        <ol className="relative mt-12 space-y-10">
          <span className="absolute left-1/2 top-0 hidden h-full w-0.5 -translate-x-1/2 bg-gold/50 md:block" aria-hidden="true" />
          {steps.map((s, i) => <Step key={i} step={s} i={i} total={steps.length} />)}
        </ol>
      </div>
    </section>
  );
}
